
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

import { Representation, RepresentationTypes } from '@/model/Representation'

@Component({})
export default class GradientLegendHeader extends Vue {
  @Ref('colors-map') canvas!: HTMLCanvasElement

  @Prop() representation!: Representation<RepresentationTypes>

  cumulativeRainfallSelected = false

  get name(): string {
    return this.representation.translationKey
  }

  get unit(): string {
    return this.representation.unitTranslationKey
  }

  get isRainfalRepresentation(): boolean {
    return this.representation.type === 'rainfall'
  }

  get shouldBeDisplayed(): boolean {
    return !this.representation.hidden
  }
}
